import { render } from "./html.content.vue?vue&type=template&id=67fd4050"
import script from "./html.content.vue?vue&type=script&lang=js"
export * from "./html.content.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__